export function Logo({ className = "", onClick }) {
  return (
    <button
      onClick={onClick}
      data-testid="brand-logo"
      className={`flex items-center gap-2.5 group ${className}`}
    >
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" aria-hidden="true">
        <circle cx="11" cy="11" r="10" stroke="currentColor" strokeWidth="1" />
        <circle cx="11" cy="11" r="5.5" stroke="currentColor" strokeWidth="1" />
        <circle cx="11" cy="11" r="1.5" fill="currentColor" />
      </svg>
      <span className="font-display text-lg tracking-tight text-paper">Aliwer</span>
    </button>
  );
}
